var _circle, _circle2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4999,
    cy: 43.0556,
    r: 15.2778,
    stroke: "#B4B4B4",
    strokeWidth: 5.55556
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5001,
    cy: 49.9991,
    r: 41.6667,
    stroke: "#B4B4B4",
    strokeWidth: 5.55556
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1410_2902",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6074 80.9537C22.7702 67.8591 35.4735 58.332 50.4989 58.332C65.5246 58.332 78.2283 67.8597 82.3907 80.9548C74.3139 89.274 63.0104 94.4433 50.4996 94.4433C37.9882 94.4433 26.6843 89.2736 18.6074 80.9537Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6074 80.9537L13.313 79.2706L12.3059 82.4384L14.6213 84.8234L18.6074 80.9537ZM82.3907 80.9548L86.3767 84.8247L88.6921 82.4398L87.6852 79.2719L82.3907 80.9548ZM23.9019 82.6368C27.3125 71.9082 37.83 63.8876 50.4989 63.8876V52.7765C33.1171 52.7765 18.2278 63.81 13.313 79.2706L23.9019 82.6368ZM50.4989 63.8876C63.1681 63.8876 73.6859 71.9087 77.0961 82.6377L87.6852 79.2719C82.7708 63.8107 67.8811 52.7765 50.4989 52.7765V63.8876ZM78.4046 77.085C71.3308 84.3711 61.4475 88.8878 50.4996 88.8878V99.9989C64.5733 99.9989 77.297 94.177 86.3767 84.8247L78.4046 77.085ZM50.4996 88.8878C39.5511 88.8878 29.6675 84.3707 22.5936 77.084L14.6213 84.8234C23.7011 94.1764 36.4253 99.9989 50.4996 99.9989V88.8878Z",
    fill: "#B4B4B4",
    mask: "url(#path-3-inside-1_1410_2902)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.4cf40c0de374eb20fadb10bf9a8066ea.svg";
export { ForwardRef as ReactComponent };